<div class="pt-3" *ngIf="notFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!notFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-5 border-rounded-10">
    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <div class="m-4" *ngIf="loadingEventType || loadingRosters">
      <h3 class="text-muted">Loading...</h3>
    </div>

    <div class="m-4" *ngIf="!(loadingEventType || loadingRosters)">

      <div class="floating-alert-container">
        <div class="alert alert-dismissible alert-success"
             *ngIf="successMessage"
             role="alert">
          {{ successMessage }}
          <button type="button" class="close" (click)="successMessage = ''">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="alert alert-dismissible alert-danger"
             *ngIf="errorMessage"
             role="alert">
          {{ errorMessage }}
          <button type="button" class="close" (click)="errorMessage = ''">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>

      <div class="rounded-table-wrapper table-responsive-lg">
        <table class="table">

          <thead>
          <tr>
            <th>Name</th>
            <th>Location</th>
            <th></th>
          </tr>
          </thead>

          <tbody>
          <tr *ngFor="let roster of rosters">
            <td>{{ roster.name }}</td>
            <td>{{ roster.location_name }}</td>
            <td class="table-button-cell">
              <div class="float-right">
                <a class="btn btn-primary btn-sm mr-2"
                      [routerLink]="'/events/setup/edit/' + eventType?.id + '/rosters/' + roster.id.toString()">
                  Edit
                </a>
                <button class="btn btn-danger btn-sm"
                        (click)="handleRemoveRoster(roster)">
                  Remove
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="rosters.length === 0">
            <td colspan="99" class="text-muted">No Rosters</td>
          </tr>
          </tbody>

        </table>
      </div>

      <div class="row">
        <div class="col">
          <a class="btn btn-outline-primary mb-4"
                  [routerLink]="'/events/setup/edit/' + eventType?.id + '/rosters/add'">
            Add Roster
          </a>
        </div>
      </div>

      <div class="float-right">
        <a class="btn btn-primary"
           [routerLink]="'/events/setup/edit/' + eventType?.id + '/schedules'">
          Continue
        </a>
      </div>
      <a [routerLink]="['/events/setup/event-types']"
         [queryParams]="{status: eventType?.status}"
         class="btn btn-secondary">
        Back
      </a>

    </div>

  </div>

</div>
